import React from "react";
import Script from "react-load-script";
import Recaptcha from "../../../ui/components/forms/configured/recaptcha/Recaptcha";
import InputField from "../../../ui/components/forms/input-field/InputField";

export const googleRecaptchaUi = {
  sandbox: ({ apiKey }) => <Recaptcha sitekey={apiKey} />,
  default: () => (
    <InputField
      id="recaptchaResponse"
      name="recaptchaResponse"
      className="hidden d-none"
      type="hidden"
      placeholder="recaptcha"
      validation={{
        validateOn: ["blur"],
        validationRegex: /.*/,
        required: true
      }}
      hideLabel
      value="FAKE_RESPONSE"
    />
  )
};

export const googleAddressAutocompleteUi = {
  sandbox: ({ apiKey, scriptLoaded }) => (
    <Script
      url={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`}
      onLoad={() => scriptLoaded("sandbox")}
    />
  ),
  default: () => null
};

export const five9SocialWidget = {
  sandbox: ({ api, scriptLoaded }) => (
    <Script
      url={`https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js`}
      onLoad={() => scriptLoaded("sandbox")}
    />
  ),
  default: () => null,
  prod: ({ api, scriptLoaded }) => (
    <Script
      url={`https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js`}
      onLoad={() => scriptLoaded("prod")}
    />
  )
};

export const equifaxDeviceVerifyUi = {
  sandbox: () => null,
  default: () => {
    window.ioGetBlackbox = () => ({
      finished: true,
      blackbox: "MOCKED_FINGERPRINT"
    });
    window.fpGetBlackbox = () => ({
      finished: true,
      blackbox: "MOCKED_FINGERPRINT"
    });
    return null;
  }
};
